// extracted by mini-css-extract-plugin
export var button = "injectable-slider-module--button--c1be7";
export var container = "injectable-slider-module--container--584e7";
export var icon = "injectable-slider-module--icon--2bd05";
export var imgBox = "injectable-slider-module--img-box--a64b9";
export var sliderBox = "injectable-slider-module--slider-box--179b7";